import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSlide } from './slides/HeroSlide';
import { CSRvsSSRSlide } from './slides/CSRvsSSRSlide';
import { ThreeLayersSlide } from './slides/ThreeLayersSlide';
import { TrafficSourcesSlide } from './slides/TrafficSourcesSlide';
import { SEOvsAISEOSlide } from './slides/SEOvsAISEOSlide';
import { AdsSlide } from './slides/AdsSlide';
import { DelegateSlide } from './slides/DelegateSlide';
import { SocialProofSlide } from './slides/SocialProofSlide';
import { OnboardingSlide } from './slides/OnboardingSlide';
import { PricingSlide } from './slides/PricingSlide';
export function App() {
  return <div className="bg-dark min-h-screen text-white selection:bg-primary selection:text-white" data-id="element-0" data-mp="31ctefp14jw7l">
      <Navigation data-id="element-1" data-mp="2wip36tktt20p" />

      <main className="flex flex-col" data-id="element-2" data-mp="28ufpkexrnkkn">
        <HeroSlide data-id="element-3" data-mp="28te0v7ntuzkg" />
        <ThreeLayersSlide data-id="element-4" data-mp="28sutgkvsztko" />
        <TrafficSourcesSlide data-id="element-5" data-mp="28s2x37udtrtc" />
        <CSRvsSSRSlide data-id="element-6" data-mp="23vupqgmff2wq" />
        <SEOvsAISEOSlide data-id="element-7" data-mp="23ujksdh8vp41" />
        <AdsSlide data-id="element-8" data-mp="23v2uj6wqr76z" />
        <DelegateSlide data-id="element-9" data-mp="23ti5fwt74ggi" />
        <SocialProofSlide data-id="element-10" data-mp="3ikhaeg9qb525" />
        <OnboardingSlide data-id="element-11" data-mp="3ij66mgga9xb1" />
        <PricingSlide data-id="element-12" data-mp="3ihv2gfixenje" />
      </main>

      <footer className="bg-black py-8 text-center text-text-dim text-sm border-t border-white/5" data-id="element-13" data-mp="3ml14tc2x3ukl">
        <p data-id="element-14" data-mp="3rbr9so7flver">© 2026 LetLois. All rights reserved.</p>
      </footer>
    </div>;
}